// extracted by mini-css-extract-plugin
export default {"diverseWrapper":"styles_diverseWrapper__bq3md","overlay":"styles_overlay__3JCPJ"};